module.exports = __webpack_public_path__ + "static/media/logo-cienciaid-min.a5023e19.svg";